import { Theme, themeMaterial } from 'ag-grid-community';

const estensaColors = {
    primary: '#8f8f8f',
    primaryDarker: '#757575',
    accent: '#8f8f8f',

    // NUOVI COLORI RIFACIMENTO UI 2025
    brandWhite: '#ffffff', // ----> NUOVO (Bianco)
    brandBlack: '#121212', // ----> NUOVO (Nero)
    brandRed: '#cb1517', // ----> NUOVO (Rosso ESAOTE)
    brandGreen: '#00a900', // ----> NUOVO (Verde)
    brandBlue: '#337ab7', // ----> NUOVO (Blu estensa)
    brandLightOutline: '#757575',
    brandDarkOutline: '#ffffff',
    // LIGHT THEME
    brandLightGrayDarkest: '#1E1E1E',
    brandLightGrayDarker: '#303030',
    brandLightMidGray: '#808080',
    brandLightGray: '#8f8f8f', // ----> NUOVO (Grigio)
    brandLightGrayLighter: '#E7E7E7',
    brandLightGrayLightest: '#F6F6F6',
    // DARK THEME
    randDarkGrayDarkest: ' #1E1E1E',
    brandDarkGrayDarker: '#303030',
    brandDarkMidGray: '#808080',
    brandDarkGray: '#8f8f8f', // ----> NUOVO (Grigio)
    brandDarkGrayLighter: '#E7E7E7',
    brandDarkGrayLightest: '#F6F6F6',

    brandLightSelected: '#c7c7c7',
    brandDarkSelected: '#585858',

    //altri
    lightOddRowColor: '#f3f3f3',
    lightHeaderText: '#303030',

    darkBackgroudColor: '#121212',
    darkOddRowColor: '#1e1e1e',
    darkText: '#ffffff',
};

export const themeEstensa: Theme = themeMaterial
    .withParams({
        primaryColor: estensaColors.primary,
        accentColor: estensaColors.accent,
        headerVerticalPaddingScale: 0.8,
        fontFamily: 'inherit',
        fontSize: 13,
        headerFontSize: 16,
        columnBorder: false,
        headerRowBorder: false,
        rowBorder: false,
        pinnedColumnBorder: false,
        cellEditingBorder: true,
        cellEditingShadow: 'none',
    })
    .withParams(
        {
            headerBackgroundColor: estensaColors.lightOddRowColor,
            headerTextColor: estensaColors.lightHeaderText,
            selectedRowBackgroundColor: estensaColors.brandLightSelected,
            rowHoverColor: estensaColors.brandLightSelected,
            oddRowBackgroundColor: estensaColors.lightOddRowColor,
        },
        'estensa-light',
    )
    .withParams(
        {
            backgroundColor: estensaColors.darkBackgroudColor,
            textColor: estensaColors.darkText,
            headerBackgroundColor: estensaColors.darkOddRowColor,
            headerTextColor: estensaColors.darkText,
            selectedRowBackgroundColor: estensaColors.brandDarkSelected,
            rowHoverColor: estensaColors.brandDarkSelected,
            oddRowBackgroundColor: estensaColors.darkOddRowColor,
            checkboxIndeterminateBorderColor: estensaColors.brandDarkGrayLighter,
            checkboxCheckedShapeColor: estensaColors.darkText,
            checkboxCheckedBorderColor: estensaColors.darkText,
            browserColorScheme: 'dark',
        },
        'estensa-dark',
    );

export const themeEstensaCustomPage = themeEstensa.withParams({
    headerFontSize: 13,
});

export const themeEstensaWorklist = themeEstensa.withParams({
    cellHorizontalPadding: 8,
});
